// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Microphone: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M41.5 27.9c-.8 0-1.4.6-1.4 1.4 0 6.3-6.4 12.8-12.8 12.8-6.3 0-12.8-6.4-12.8-12.8 0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4c0 7.4 6.8 14.6 14.1 15.4v7.5c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-7.5c7.3-.8 14.1-8.1 14.1-15.4.2-.8-.5-1.4-1.2-1.4z"/><path d="M27.3 38.6c5.2 0 9.4-4.2 9.4-9.4v-18c0-5.2-4.2-9.4-9.4-9.4s-9.4 4.2-9.4 9.4v18c.1 5.2 4.3 9.4 9.4 9.4zm-6.6-27.3c0-3.7 3-6.6 6.6-6.6 3.7 0 6.6 3 6.6 6.6v18c0 3.7-3 6.6-6.6 6.6-3.7 0-6.6-3-6.6-6.6v-18z"/></svg>;
};

export default React.memo(Microphone);
